import { render, staticRenderFns } from "./salesRecords.vue?vue&type=template&id=70b7d548&scoped=true&"
import script from "./salesRecords.vue?vue&type=script&lang=js&"
export * from "./salesRecords.vue?vue&type=script&lang=js&"
import style0 from "./salesRecords.vue?vue&type=style&index=0&id=70b7d548&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b7d548",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/deploy/iot-product-tool/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70b7d548')) {
      api.createRecord('70b7d548', component.options)
    } else {
      api.reload('70b7d548', component.options)
    }
    module.hot.accept("./salesRecords.vue?vue&type=template&id=70b7d548&scoped=true&", function () {
      api.rerender('70b7d548', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/factory/outBound/salesRecords.vue"
export default component.exports